import isNil from 'lodash/isNil';
import dayjs, {
  Dayjs,
  getOrgNow,
} from 'utils/dayjs';

export const REQUIRED_ADDRESS_FIELDS = [
  'street',
  'city',
  'state',
  'zipCode',
];

export function getDefaultInactiveEffectiveTill(): Dayjs {
  return getOrgNow().startOf('day');
}

export function validateEffectiveFrom(
  effectiveFrom: Dayjs | null | undefined,
  { effectiveTill }: { effectiveTill?: Dayjs | null },
): true | string {
  if (isNil(effectiveFrom) || !effectiveFrom.isValid()) {
    return true;
  }

  if (effectiveFrom.isAfter(getOrgNow(), 'day')) {
    return 'Effective from date cannot be in the future.';
  }

  if (!isNil(effectiveTill) && effectiveFrom.isAfter(effectiveTill, 'day')) {
    return 'Effective from date cannot be after effective till date.';
  }

  return true;
}

export function validateEffectiveTill(
  effectiveTill: Dayjs | null | undefined,
  { effectiveFrom }: { effectiveFrom?: Dayjs | null },
): true | string {
  if (isNil(effectiveTill) || !effectiveTill.isValid()) {
    return true;
  }

  if (effectiveTill.isAfter(getOrgNow(), 'day')) {
    return 'Effective till date cannot be in the future.';
  }

  if (!isNil(effectiveFrom) && effectiveTill.isBefore(dayjs(effectiveFrom), 'day')) {
    return 'Effective till date cannot be before effective from date.';
  }

  return true;
}
